import { Loader2 } from "lucide-react";
const Icons = () => {
  return <Loader2 className="h-8 w-8 animate-spin text-neutral-400" />;
};

const LoadingMessage = () => {
  return (
    <div className="text-center w-[316px] h-[44px]">
      <span className="text-gray-600 body-1-normal-medium">
        태그 빌딩중입니다. 잠시만 기다려주세요.
      </span>
    </div>
  );
};

export const PreviewLoadingView = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full space-y-6">
      <Icons />
      <LoadingMessage />
    </div>
  );
};

export const TablePreviewLoadingView = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full space-y-6">
      <Icons />
      <span className="text-gray-600 body-1-normal-medium">
        표를 그리는 중입니다. 잠시만 기다려주세요.
      </span>
    </div>
  );
};
